import {styles} from "../../../common/style";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {constance} from "../../../common/constance/constance";
import {MenuItem, MenuList, Paper} from "@mui/material";
import {Department} from "../../../interface/department.interface";
import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import {MenuInterface} from "../../../interface/menu.interface";
import {common} from "../../../common/common";
import {isMobile} from "react-device-detect";

export default function SelectDepartmentComponent(props: { state: any, setState: any, workplace: string }) {
    const [selectOptionOpen, setSelectOptionOpen] = useState(false);
    const [departmentList, setDepartmentList] = useState<Department[]>([]);
    let {id, workplace, no, page} = common.getQuery();
    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);

    useEffect(() => {
        axios.get(constance.api.getDepartmentList).then(value => {
            console.log('constance.api.getDepartmentList');
            setDepartmentList(value.data.departmentList)
        })
    }, []);

    function handleSelectOptionOpen(isOpen: boolean) {
        setSelectOptionOpen(isOpen)
    }

    function selectDepartment(e: React.MouseEvent<HTMLLIElement>, department: Department) {
        setSelectOptionOpen(false);
        props.setState(department);
    }
    let fontSize: any = isMobile? "subtitle2" :"subtitle1";

    return (
        <Box sx={{
            width: 1,
            display: 'flex',
            justifyContent: 'flex-start', alignItems: 'center',
            mb: 1,
            backgroundColor: 'var(--scc-surface)',
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 1,
                p: 2,
                width: 100,
                backgroundColor: '#696969',
                border: styles.border,
                borderRight: '0px'
            }}>
                <Typography sx={{color: 'white'}}> 부서 선택 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                {/* 부서 선택 textfield */}
                <TextField placeholder="사업장 선택 후 선택해주세요."
                           value={props.state._id == '' ? '' : `[${constance.workplaceNameMap[props.state.workplace]}] ${props.state.departmentName}`}
                           onClick={() => handleSelectOptionOpen(props.state.workplace == '-1' ? false : true)}
                           disabled={props.state.workplace == '-1'}
                           variant="outlined"
                           sx={{width: 1, backgroundColor: 'var(--scc-surface)'}}
                />
                <Paper sx={{
                    width: 320, maxWidth: '100%',
                    position: 'absolute',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    zIndex: 10,
                    display: selectOptionOpen ? 'flex' : 'none',
                }}>
                    <MenuList sx={{width: 1,}}>
                        {
                            departmentList.map((department: Department, index: number) => {
                                if (department.workplace != props.workplace) return;
                                if (department.departmentName == "대표이사"
                                    || department.departmentName == "아산"
                                    || department.departmentName == "담양"
                                    || department.departmentName == "밀양"
                                    || department.departmentName == "기흥"
                                    || department.departmentName == "테스트"
                                    || department.departmentName == "ONEK") {
                                    return;
                                }
                                if (department.departmentName.match(/\(아산\)|\(담양\)|\(밀양\)|\(기흥\)|\(용인\)/g) != null) {
                                    department.departmentName = department.departmentName.replace(/\(아산\)|\(담양\)|\(밀양\)|\(기흥\)|\(용인\)/g, "");
                                }
                                return (
                                    <MenuItem value={department._id}
                                              key={index}
                                              sx={{width: 1}}
                                              onClick={(e) => selectDepartment(e, department)}
                                    >
                                        <Typography variant={fontSize}>
                                            {`${department.departmentName}`}
                                        </Typography>
                                    </MenuItem>
                                );
                            })
                        }

                    </MenuList>
                </Paper>
            </Box>
        </Box>
    )
}